<script setup>
import { computed } from 'vue'
import { useGlobalStore } from '@stores/global'
import Loading from '@components/global/Loading.vue'
import Hero from '@sections/index/Hero.vue'
import FeaturedEvents from '@sections/global/FeaturedEvents.vue'
import CalendarSection from '@sections/index/Calendar.vue'
import LatestNews from '@sections/index/LatestNews.vue'

const global = useGlobalStore()

const homepage = computed(() => global.pages.find((page) => page.slug === 'homepage'))

const blocks = {
	hero_homepage: Hero,
	featured_events: FeaturedEvents,
	calendar: CalendarSection,
	latest_news: LatestNews,
}

const sections = computed(() => {
	let sectionIndex = 0

	return (homepage.value?.content ?? [])
		.filter((block) => blocks[block.type])
		.map((block) => ({
			...block,
			class: block.type === 'hero_homepage' ? null : sectionIndex++ % 2 === 0 ? 'bg-snk-light-800' : 'bg-white',
		}))
})
</script>

<template>
	<Loading v-if="!homepage" />
	<template v-else>
		<component :is="blocks[block.type]" v-for="(block, index) in sections" :key="index" :data="block.data" :class="block.class" />
	</template>
</template>
